var config = require('../config.js')
module.exports = {
    userRankList: config.host + '/market/api/v1/userRank/list/c', //等级列表
    // userRankList: config.host + '/market/api/v1/userRank/list/v4/c', //等级列表
    getGrowUpDetail: config.host + '/market/api/v1/userRank/getGrowUpDetail/c', //获取成长值明细
    memberJobList: config.host + '/market/api/v1/userRank/memberJobList/c', //会员成长任务
    userRank: config.host + '/market/api/v1/userRank/get/c', //等级查询
}